import { replace } from 'react-router-redux';
import {
  orderBy,
  flattenDeep,
  compact,
  isEqual,
  find,
  keys,
  map,
  get,
  omit,
  startsWith,
} from 'lodash';
import { readWM, save, create, read, list, custom } from 'utils/Api';

import { addNotification } from 'reapop';

import { xSelectSingle } from 'utils/xSelect';
import * as types from 'constants/ActionTypes';

export const requestEvaluations = () => ({
  type: types.COURSE_EVAL_LIST_REQUEST,
});

export const requestEvaluationsSuccess = evaluations => ({
  type: types.COURSE_EVAL_LIST_SUCCESS,
  evaluations,
});

export const requestEvaluationsFailure = error => ({
  type: types.COURSE_EVAL_LIST_FAILURE,
  evaluationsError: error,
});

export const fetchEvaluations = () =>
  async (dispatch, getState) => {
    try {
      dispatch(requestEvaluations());

      const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

      const config = {
        headers: { Authorization: `Bearer ${token}` },
        url: `/kjarni/api/v2/CourseEvaluations/GetEmployeeEvaluations(employeeMasterId=${EmployeeMasterID})`,
      };

      const evaluations = get(await custom(config), 'data.value', []);
      dispatch(requestEvaluationsSuccess(evaluations));

    } catch (error) {
      dispatch(requestEvaluationsFailure(error));
    }
  };

export const requestEvaluation = CourseAttendeeID => ({
  type: types.COURSE_EVAL_REQUEST,
  CourseAttendeeID,
});

export const requestEvaluationSuccess = ({ CourseAttendee, CourseEvaluation, CourseEvaluationAnswers }) => ({
  type: types.COURSE_EVAL_SUCCESS,
  CourseAttendee,
  CourseEvaluation,
  CourseEvaluationAnswers,
});

export const requestEvaluationFailure = evaluationError => ({
  type: types.COURSE_EVAL_FAILURE,
  evaluationError,
});

export function sortChildren(obj) {
  if (obj.Children) {
    return { ...obj.Entity, ...obj, Children: orderBy(obj.Children.map(sortChildren), ['Order'], ['asc']) };
  }
  return { ...obj.Entity, ...obj };
}

const flattenChildren = (obj) => {
  if (obj.Children) {
    return [obj, ...flattenDeep(obj.Children.map(flattenChildren))];
  }
  return obj;
};

export function fetchOptions(qae, token) {
  const { QAInputID } = qae;
  const config = {
    entity: 'QAInput',
    entityID: QAInputID,
    headers: { Authorization: `Bearer ${token}` },
  };

  return read(config)
    .then(({ data }) => ({ ...qae, QAInput: data }));
}

export const initAnswers = ({ CourseAttendee, CourseEvaluation }) =>
  (dispatch, getState) => {
    const { loginReducer: { user: { token } } } = getState();
    if (CourseAttendee.EvaluationRootAnswerID) {
      // The CourseAttendee has a root answer ID
      const answerConf = {
        entity: 'QAAnswer',
        headers: { Authorization: `Bearer ${token}` },
        data: xSelectSingle([{
          field: 'RootAnswerID',
          value: CourseAttendee.EvaluationRootAnswerID,
          relation: 'eq',
        }]),
      };
      list(answerConf)
        .then(({ data }) => dispatch(requestEvaluationSuccess({
          CourseAttendee,
          CourseEvaluation,
          CourseEvaluationAnswers: data,
        })))
        .catch(error => dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID)));
    } else {
      // The CourseAttendee does not ahve a root answer ID
      const createRoot = {
        entity: 'QAAnswer',
        headers: { Authorization: `Bearer ${token}` },
        data: { QAElementID: CourseEvaluation.QAElementID },
      };
      create(createRoot)
        .then(({ data }) => {
          const saveAttendee = {
            entity: 'CourseAttendee',
            headers: { Authorization: `Bearer ${token}` },
            data: {
              ...CourseAttendee.Entity,
              EvaluationRootAnswerID: data.QAAnswerID,
            },
          };
          save(saveAttendee)
            .then((NewCourseAttendee) => {
              const groups = CourseEvaluation.QAElements.filter(e => e.QAElementType === 2);

              /* To initialize the answers correctly we need to create QAAnswers for
          all the groups in the QAElement tree. This is done here so that it is
          not required on submit or save of the form */
              const answerGroups = groups.map(({
                QAElementID,
                Label,
                Order,
              }) => create({
                entity: 'QAAnswer',
                headers: { Authorization: `Bearer ${token}` },
                data: {
                  QAAnswerParentID: data.QAAnswerID,
                  RootAnswerID: data.QAAnswerID,
                  QAElementID,
                  QAAnswerValue: Label,
                  QAAnswerText: Label,
                  QAAnswerOrder: Order,
                },
              }));
              Promise.all(answerGroups)
                .then(CEAnswers =>
                  // dispatch(setManagerAnswers(PMAppraisalID, { RootAnswerID: managerRootAnswerID, QAAnswers: ans.filter(x => x.RootAnswerID === managerRootAnswerID) }));
                  // dispatch(requestAppraisalByIdSuccess({ ...appraisal, ...newAppraisal, Entity: newAppraisal }));
                  dispatch(requestEvaluationSuccess({
                    CourseAttendee: {
                      ...CourseAttendee,
                      ...NewCourseAttendee.data,
                      Entity: NewCourseAttendee.data,
                    },
                    CourseEvaluation,
                    CourseEvaluationAnswers: CEAnswers.map(x => ({ ...x.data })),
                  })))
                .catch(error => dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID)));
            })
          /*
        dispatch(requestEvaluationSuccess({
          CourseAttendee: {
            ...CourseAttendee,
            ...NewCourseAttendee,
            Entity: NewCourseAttendee,
          },
          CourseEvaluation,
          CourseEvaluationAnswers: [],
        })),
        */
            .catch(error => dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID)));
        })
        .catch(error => dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID)));

    }
  };

export const fetchEvaluation = CourseAttendeeID =>
  async (dispatch, getState) => {
    try {
      dispatch(requestEvaluation(CourseAttendeeID));
      const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

      const configAttendee = {
        entity: 'CourseAttendee',
        entityID: CourseAttendeeID,
        headers: { Authorization: `Bearer ${token}` },
      };

      const { data: CourseAttendee } = await read(configAttendee);
      const CourseID = get(CourseAttendee, 'CourseID');

      if (!CourseAttendee || !CourseID) {
        return dispatch(requestEvaluationFailure(
          new Error('Þessi námskeiðsskráning er ekki til.'),
          CourseAttendeeID,
        ));
      }

      const config = {
        entity: 'Course',
        entityID: CourseID,
        headers: { Authorization: `Bearer ${token}` },
      };
      const { data: Course } = await read(config);

      if (!Course.CourseEvaluationID) {
        return dispatch(requestEvaluationFailure(
          new Error('Ekkert námskeiðsmat er skráð á þetta námskeið.'),
          CourseAttendeeID,
        ));
      }

      if (CourseAttendee.EmployeeMasterID !== EmployeeMasterID) {
        return dispatch(requestEvaluationFailure(
          new Error('Þetta er ekki þín námskeiðsskráning.'),
          CourseAttendeeID,
        ));
      }

      const evalConfig = {
        entity: 'CourseEvaluation',
        entityID: Course.CourseEvaluationID,
        headers: { Authorization: `Bearer ${token}` },
      };

      const { data: CourseEvaluation } = await read(evalConfig);

      if (!CourseEvaluation.CourseEvaluationID) {
        return dispatch(requestEvaluationFailure(
          new Error('Námskeiðsmatið á þessari námskeiðsskráning er ekki til.'),
          CourseAttendeeID,
        ));
      }
      if (!CourseEvaluation.QAElementID) {
        return dispatch(requestEvaluationFailure(
          new Error('Námskeiðsmatið er ekki með neinar spurningar.'),
          CourseAttendeeID,
        ));
      }
      const configElement = {
        entity: 'QAElement',
        entityID: CourseEvaluation.QAElementID,
        headers: { Authorization: `Bearer ${token}` },
      };

      const { data: QAElement } = await readWM(configElement);

      if (!QAElement) {
        return dispatch(requestEvaluationFailure(
          new Error('Námskeiðsmatið er ekki með neinar spurningar.'),
          CourseAttendeeID,
        ));
      }
      const initQAElements = flattenChildren(sortChildren(QAElement));
      const QAElements = initQAElements.map((e) => {
        if (e.QAInput) {
          return { ...e, ...e.Entity, QAInput: { ...e.QAInput.Entity, ...e.QAInput } };
        }
        return { ...e, ...e.Entity };
      });
      return dispatch(initAnswers({
        CourseAttendee: {
          ...CourseAttendee,
          CourseName: Course.CourseName,
          Entity: CourseAttendee,
        },
        CourseEvaluation: {
          ...CourseEvaluation,
          QAElement: sortChildren(QAElement),
          QAElements,
        },
      }));
    } catch (error) {
      return dispatch(requestEvaluationFailure(error, CourseAttendeeID));
    }
  };

export const requestSaveEvaluation = () => ({
  type: types.COURSE_EVAL_SAVE_REQUEST,
});
export const requestSaveEvaluationSuccess = () => ({
  type: types.COURSE_EVAL_SAVE_SUCCESS,
});
export const requestSaveEvaluationFailure = error => ({
  type: types.COURSE_EVAL_SAVE_FAILURE,
  evaluationError: error,
});

const convertFormData = (
  formData,
  CourseAttendee,
  CourseEvaluation,
  CourseEvaluationAnswers,
) => {
  /* NOTE:
      CHECKBOX
        * get QAAnswerValue from redux form value
        * get QAAnswerText from redux form name last group
      NOTE: ATTACHMENT questions put on hold!
      ATTACHMENT
        * on load of file send to repo
        * QAAnswerText is the file name
        * QAAnswerValue is the GUID of the file returned from repo
      TEXT_FIELDS
        * QAAnswerValue and QAAnswerText are set to the rf value
      DATE
        * set QAAnswerText to human version
        * set QAAnswerValue to datetime stamp
      RADIO AND SCALE
        * set QAAnswerText to the option label
        * set QAAnswerValue to QAInputOptionID or HrQualificationScaleEntryID
  */

  const { QAElements } = CourseEvaluation;
  const RootAnswerID = CourseAttendee.EvaluationRootAnswerID;

  /* Map through all the fields submited through the Redux form */
  const ansrs = map(keys(formData), (key) => {
    if (startsWith(key, 'COMMENT')) { return null; }
    const QAAnswerValue = formData[key];
    /* Split the key into its components
    example: '345-34045'
    becomes ['345', '34045'] */
    const qaKeys = key.split`-`;

    /* We use the Redux field names to identify information about the elements */
    const QAInputAnswerType = Number(qaKeys[0]);
    const QAElementID = Number(qaKeys[1]);
    const QAInputOptionLabel = qaKeys[2];

    /* QAElement information */
    const {
      QAInput, Order, Level, QAElementParentID, AllowComment,
    } = find(QAElements, ['QAElementID', QAElementID]);

    const option = QAInputAnswerType === 6 ?
      find(QAInput.HrQualificationScaleEntries, ['HrQualificationScaleEntryID', QAAnswerValue]) :
      find(QAInput.QAInputOptions, ['QAInputOptionID', QAAnswerValue]);

    const checkBoxText = atob(QAInputOptionLabel || '');
    const optionText = option ? option.HrQualificationScaleEntryName || option.QAInputOptionLabel : '';
    const QAAnswerText = checkBoxText || optionText || QAAnswerValue;
    let QAAnswerComment = null;

    if (AllowComment) {
      QAAnswerComment = formData[`COMMENT-${QAInputAnswerType}-${QAElementID}`];
    }

    /* If the Element is higher than 2 the Element is inside a group, then
    we have to set the correct QAAnswerParentID. */
    const QAAnswerParent = Level <= 2 ? RootAnswerID : find(CourseEvaluationAnswers, ['QAElementID', QAElementParentID]);
    const QAAnswerParentID = QAAnswerParent.QAAnswerID;

    let existing;
    let existingValue;
    let existingComment;
    let existingID;
    const existingAnswers = CourseEvaluationAnswers.filter(ans => ans.QAElementID === QAElementID);
    // Check existingAnswers to see if we are adding a new answer or updating one.
    if (existingAnswers.length) {
      /* If we have a checkbox question we have to see if
        this option alread has an answer */
      if (QAInputAnswerType === 3) {
        existing = find(existingAnswers, ['QAAnswerText', atob(QAInputOptionLabel)]);
      } else {
        existing = existingAnswers[0];
      }
      existingValue = existing && existing.QAAnswerValue;
      existingID = existing && existing.QAAnswerID;
      existingComment = existing && existing.QAAnswerComment;
    }

    if (isEqual(existingValue, QAAnswerValue) && isEqual(existingComment, QAAnswerComment)) {
      return undefined;
    }

    const def = {
      QAAnswerParentID,
      QAElementID,
      QAAnswerValue,
      QAAnswerText,
      QAAnswerComment,
      QAAnswerOrder: Order,
      RootAnswerID,
    };

    if (existingID) {
      return { QAAnswerID: existingID, ...def };
    }

    return def;
  });

  return compact(ansrs);
};

export const saveEvaluation = (formData, CourseAttendeeID, isSubmit = false) =>
  (dispatch, getState) => {
    const {
      loginReducer: { user: { token } },
      CourseEvaluationReducer: {
        evaluationById: {
          [CourseAttendeeID]: {
            CourseAttendee,
            CourseEvaluation,
            CourseEvaluationAnswers,
          },
        },
      },
    } = getState();
    dispatch(requestSaveEvaluation(CourseAttendee.CourseAttendeeID));
    const QAAnswers = convertFormData(
      formData,
      CourseAttendee,
      CourseEvaluation,
      CourseEvaluationAnswers,
    );
    return Promise.all(QAAnswers.map((data) => {
      if (data.QAAnswerID) {
        return save({ entity: 'QAAnswer', data, headers: { Authorization: `Bearer ${token}` } });
      }
      return create({ entity: 'QAAnswer', data, headers: { Authorization: `Bearer ${token}` } });
    }))
      .then(() => {
      // TODO: Save CourseAttendee
        const status = {
          entity: 'CourseAttendee',
          headers: { Authorization: `Bearer ${token}` },
          data: {
            ...omit(
              CourseAttendee,
              ['CreateDate', 'CreateUserID', 'ModifyDate', 'ModifyUserID',
                'RowVersion', 'KeyID', 'UniqueID', 'EntityID'],
            ),
            EvaluationStatus: isSubmit ? 2 : 1,
          },
        };
        save(status)
          .then(() => {
            dispatch(requestSaveEvaluationSuccess());
            dispatch(addNotification({
              title: 'Vistað',
              message: 'Námskeiðsmat hefur verið vistað',
              status: 'success',
              dismissible: true,
              dismissAfter: 4000,
            }));
            if (isSubmit) {
              dispatch(replace('/'));
            } else {
              dispatch(fetchEvaluation(CourseAttendeeID));
            }
          }).catch(error => dispatch(requestSaveEvaluationFailure(error)));
      }).catch(error => dispatch(requestSaveEvaluationFailure(error)));
  };

export const requestSubmitEvaluation = () => ({
  type: types.COURSE_EVAL_SUBMIT_REQUEST,
});
export const requestSubmitEvaluationSuccess = () => ({
  type: types.COURSE_EVAL_SUBMIT_SUCCESS,
});
export const requestSubmitEvaluationFailure = error => ({
  type: types.COURSE_EVAL_SUBMIT_FAILURE,
  evaluationError: error,
});

export const submitEvaluation = (formData, CourseAttendeeID) =>
  (dispatch) => {
    dispatch(saveEvaluation(formData, CourseAttendeeID, true));
  };



// WEBPACK FOOTER //
// ./src/actions/CourseEvaluation.js